export default __webpack_public_path__ + "static/BgHomeM-cf38f632310ff18cf439b4510e42abb8.png";